export const backheadTitles = {
    current: { zh: "当前展出", en: "Current Exhibitions" },
    iconic: { zh: "经典展览", en: "Iconic Exhibitions" },
    upcoming: { zh: "即将展出", en: "Upcoming Exhibitions" },
    report: { zh: "报道", en: "Reports" },
    guided: { zh: "公益讲解", en: "Guided Tours" },
    videos: { zh: "视频", en: "Videos" },
    photos: { zh: "图片", en: "Photos" },
    introduction: { zh: "美术馆简介", en: "Introduction of Art museum" },
    timeAddress: { zh: "时间和地址", en: "Time&Address" },
    artShop: { zh: "艺术品商店", en: "Art Shop" },
    panorama: { zh: "全景", en: "Panorama" },
    details: { zh: "详情页", en: "DetailPage" },
    events: { zh: "公教活动", en: "Events" },
    aboutUs: { zh: "关于我们", en: "About Us" },
    team: { zh: "美术馆架构", en: "Team" },
    mobileDetails: { zh: "详情页", en: "DetailPage" },
};

export const headerLabels = {
    home: { zh: "首页", en: "Home" },
    buyTickets: { zh: "点此购票", en: "Buy Tickets" },
    sections: [
        {
            title: { zh: "展览", en: "Exhibitions" },
            items: [
                { to: "/current", label: { zh: "当前展出", en: "Current" } },
                { to: "/Iconic", label: { zh: "经典展览", en: "Iconic" } },
                { to: "/upcoming", label: { zh: "即将展出", en: "Upcoming" } },
            ],
        },
        {
            title: { zh: "媒体中心", en: "Press center" },
            items: [
                { to: "/Report", label: { zh: "报道", en: "Reports" } },
                { to: "/Photes", label: { zh: "图片", en: "Photos" } },
                { to: "/Videos", label: { zh: "视频", en: "Videos" } },
                { to: "/Around", label: { zh: "全景", en: "Panorama" } },
            ],
        },
        {
            title: { zh: "项目", en: "Programs" },
            items: [
                { to: "/Events", label: { zh: "公教活动", en: "Events" } },
                { to: "/Guided", label: { zh: "公益讲解", en: "Guided Tours" } },
                { to: "/artShop", label: { zh: "艺术品商店", en: "Art Shop" } },
            ],
        },
        {
            title: { zh: "关于我们", en: "About Us" },
            items: [
                { to: "/timeAddress", label: { zh: "时间和地址", en: "Time&Address" } },
                {
                    to: "/Introduction",
                    label: { zh: "美术馆简介", en: "Introduction of Art museum" },
                },
                { to: "/team", label: { zh: "美术馆架构", en: "Team" } },
            ],
        },
    ],
};

export const footerLabels = {
    links: { zh: "友情链接", en: "Friend Links" },
    findUs: { zh: "找到我们", en: "Find Us" },
    handle: {
        zh: "@北京民生现代美术馆",
        en: "@Beijing Minsheng Museum of Modern Art",
    },
};

export const pageLabels = {
    artShop: {
        intro: { zh: "商店介绍", en: "Shop Introduction" },
        recommended: { zh: "推荐产品", en: "Recommended Products" },
    },
    events: {
        intro: { zh: "服务介绍", en: "Service Introduction" },
        service: { zh: "馆方服务介绍", en: "Museum Service Introduction" },
        dec: {
            zh: "公益合作是指不同组织、企业、个人或政府之间为了共同推动社会公益事业而进行的合作。这种合作旨在集合各方资源、技术和影响力，以更有效地解决社会问题，改善社会环境，增进公共利益。以下是对公益合作的一些洋细介绍:北公益合作是指不同组织、企业、个人或政府之间为了共同推动社会公益事业而进行的合作。这种合作旨在集合各方资源、技术和影响力，以更有效地解决社会问题，改善社会环境，增进公共利益。以下是对公益合作的一些详细介绍。",
            en: "Public welfare cooperation refers to the collaboration between different organizations, enterprises, individuals, or governments to jointly promote social welfare undertakings. This cooperation aims to gather resources, technology, and influence from all parties to more effectively solve social problems, improve the social environment, and enhance public interests. Here are some detailed introductions to public welfare cooperation: North Public Welfare Cooperation refers to the cooperation between different organizations, enterprises, individuals, or governments to jointly promote social welfare undertakings. This cooperation aims to gather resources, technology, and influence from all parties to more effectively solve social problems, improve the social environment, and enhance public interests. Here are some detailed introductions to public welfare cooperation.",
        },
    },
    guided: {
        intro: { zh: "展厅亮点", en: "Gallery Highlights" },
    },
    timeAddress: {
        intro: { zh: "开放时间", en: "Opening Hours" },
        addr: { zh: "地址", en: "Address" },
        traffic: { zh: "交通指南", en: "Traffic Guide" },
    },
    current: {
        intro: { zh: "展览", en: "Exhibition" },
        details: { zh: "详情页面", en: "DetailPage" },
    },
    panorama: {
        href: { zh: "全景展示", en: "Panorama" },
    },
};

export const mobileLabels = {
    search: { zh: "查找", en: "Search" },
    openToday: { zh: "今日开馆", en: "Open today" },
    closedToday: { zh: "今日闭馆", en: "Closed today" },
};

export const searchLabels = {
    placeholder: { zh: "专题", en: "TOPIC AAAA" },
    results: { zh: "查找结果", en: "Search Results" },
    noResults: {
        zh: "未找到相关展览，请尝试其他关键词",
        en: "No results found. Please try a different keyword.",
    },
};
// 图片域名公用
export const imageurl = "http://api.msam.net.cn/";